import React from 'react';
import Button from "../../button/button.jsx";
import {FaPen} from "react-icons/fa";

const EditorButton = ({ setCallEditor, callEditor }) => {
    return (
        <>
            <section className={`flex flex-row pl-2!`}>
                <Button target={'primary-outline'} className={`${callEditor ? 'opacity-100! bg-[#f6f6f6]! transform translate-y-2.5' : 'opacity-85! transform translate-y-2.75'} border-0! hover:opacity-100! print:hidden! w-8! p-0!`} onClick={() => setCallEditor(prev => !prev)} title={callEditor ? 'Ocultar legenda' : 'Adicionar legenda'}><FaPen size={12}/></Button>
            </section>
        </>
    );
};

export default EditorButton;